var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Link } from "core/components/Link";
import { fontWeight, colors, easing, shadows, } from "core/styles/snippets";
import { content } from "core/utils";
export var GoButton = function (_a) {
    var url = _a.url, className = _a.className, isColourLogo = _a.isColourLogo, onClick = _a.onClick, children = _a.children, trackingObject = _a.trackingObject, _b = _a.plus, plus = _b === void 0 ? false : _b, _c = _a.withoutLogo, withoutLogo = _c === void 0 ? false : _c, props = __rest(_a, ["url", "className", "isColourLogo", "onClick", "children", "trackingObject", "plus", "withoutLogo"]);
    var logoSrc = plus
        ? (isColourLogo
            ? "/images/logos/vtm-go-plus-color-2024.svg"
            : "/images/logos/vtm-go-plus.svg")
        : (isColourLogo
            ? "/images/logos/vtm-go-pink.svg"
            : "/images/logos/vtm-go.svg");
    return (url ? (React.createElement(StyledButton, __assign({ url: url, target: "__blank", rel: "noopener", onClick: onClick, trackingObject: trackingObject, className: className }, props),
        children,
        !withoutLogo &&
            React.createElement(Logo, { src: logoSrc, alt: plus ? content.button.vtmGoPlus.alt : content.button.vtmGo.alt }))) : (React.createElement(StyledButton, __assign({ as: "div", onClick: onClick, trackingObject: trackingObject, className: className }, props),
        children,
        !withoutLogo &&
            React.createElement(Logo, { src: logoSrc, alt: plus ? content.button.vtmGoPlus.alt : content.button.vtmGo.alt }))));
};
var StyledButton = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1.59375rem;\n  padding: 0.625rem 1rem;\n  font-size: 1rem;\n  color: ", ";\n  ", ";\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 1;\n  white-space: nowrap;\n  ", "\n  background-color: ", ";\n  transition: all 0.75s ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    border: 2px solid ", ";\n    outline-offset: 0px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1.59375rem;\n  padding: 0.625rem 1rem;\n  font-size: 1rem;\n  color: ", ";\n  ", ";\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 1;\n  white-space: nowrap;\n  ", "\n  background-color: ", ";\n  transition: all 0.75s ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    border: 2px solid ", ";\n    outline-offset: 0px;\n  }\n"])), colors.white, fontWeight.bold, shadows.buttonHover, colors.darkBackground, easing.expo.out, colors.linkHover, colors.white);
export var Logo = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 0.75rem;\n  margin-left: 0.25rem;\n"], ["\n  height: 0.75rem;\n  margin-left: 0.25rem;\n"])));
var templateObject_1, templateObject_2;
